import lang from '../../lib/language';
import { PlanPhaseTypeEnum } from '../../lib/models/crm/types';
import { isFundedPhase } from '../../lib/store/account-flow/lifecycle';

import WarningIcon from '../../assets/img/warning-icon.svg';

import styles from './AccountSetupNotification.module.scss';

export const ACCOUNT_SETUP_NOTIFICATION_ID = 'accountSetupNotification';

type Props = {
  isDemoSetup: boolean;
  phase?: PlanPhaseTypeEnum;
};

const getDescription = ({ isDemoSetup, phase }: Props): string => {
  if (phase && isFundedPhase(phase)) {
    return lang.fundedPhaseAccountSetUp(phase);
  }

  return isDemoSetup
    ? lang.commonDemoAccountSettingUpReady()
    : lang.commonAccountSettingUpReady();
};

// Whether this notification is the one to show is decided by `NotificationsManager`.
const AccountSetupNotification = ({ isDemoSetup, phase }: Props) => (
  <div className={styles.container} id={ACCOUNT_SETUP_NOTIFICATION_ID}>
    <div className={styles.content}>
      <img className={styles.warningIcon} src={WarningIcon} alt="Warning" />
      <div>{getDescription({ isDemoSetup, phase })}</div>
    </div>
  </div>
);

export default AccountSetupNotification;
